import React from 'react';
import SafeIcon from '../../../common/SafeIcon';
import { Icons } from '../../../shared/icons';
import ClassificationSelector from './ClassificationSelector';

export default function ClassificationStep({ 
  form, 
  setField,
  classification,
  setClassification,
  certificateType,
  errors = {}
}) {
  return (
    <div className="classification-step">
      <div className="panel classification-panel">
        <h3>Installation Safety Classification</h3>
        <p className="field-hint">
          The overall classification determines whether the installation is safe to continue in service
        </p>
      </div>

      <ClassificationSelector
        value={classification}
        onChange={setClassification}
        perFault={false}
        errors={errors.classification}
      />

      <label className="cert-field">
        General Installation Condition
        <textarea
          value={form.general_condition}
          onChange={(e) => setField('general_condition', e.target.value)}
          placeholder="Describe the overall condition of the gas installation"
          rows={3}
          aria-label="General installation condition"
        />
      </label>

      <label className="cert-field">
        Installation Satisfactory
        <div className="toggle-group">
          <button
            type="button"
            className={`toggle-option ${form.installation_satisfactory === true ? 'selected' : ''}`}
            onClick={() => setField('installation_satisfactory', true)}
            aria-label="Mark installation as satisfactory"
            aria-pressed={form.installation_satisfactory === true}
          >
            <SafeIcon icon={Icons.Check} size={20} />
            YES
          </button>
          <button
            type="button"
            className={`toggle-option ${form.installation_satisfactory === false ? 'selected' : ''}`}
            onClick={() => setField('installation_satisfactory', false)}
            aria-label="Mark installation as not satisfactory"
            aria-pressed={form.installation_satisfactory === false}
          >
            <SafeIcon icon={Icons.X} size={20} />
            NO
          </button>
        </div>
      </label>

      {form.installation_satisfactory === false && (
        <>
          <label className="cert-field">
            Remedial Work Required
            <textarea
              value={form.remedial_work_required}
              onChange={(e) => setField('remedial_work_required', e.target.value)}
              placeholder="Describe the remedial work required"
              rows={3}
              aria-label="Remedial work required"
            />
          </label>

          <label className="cert-field">
            Further Investigation Required
            <textarea
              value={form.further_investigation_required}
              onChange={(e) => setField('further_investigation_required', e.target.value)}
              placeholder="Describe any further investigation needed"
              rows={3}
              aria-label="Further investigation required"
            />
          </label>
        </>
      )}

      {/* GWN-specific fault summary */}
      {certificateType === 'gwn' && form.faults && form.faults.length > 0 && (
        <div className="panel fault-summary-panel">
          <h4>Fault Classification Summary</h4>
          <ul className="fault-summary-list">
            {form.faults.map((fault, idx) => (
              <li key={idx} className="fault-summary-item">
                <span className="fault-location">{fault.location || 'Unspecified'}</span>
                <span className={`fault-classification fault-classification-${fault.classification}`}>
                  {fault.classification?.replace('_', ' ').toUpperCase()}
                </span>
              </li>
            ))}
          </ul>
          {errors.conflict && (
            <div className="error-message conflict-error">
              <SafeIcon icon={Icons.AlertTriangle} size={16} />
              {errors.conflict}
            </div>
          )}
        </div>
      )}

      <p className="field-hint warning-hint">
        <SafeIcon icon={Icons.AlertTriangle} size={14} />
        Select "Immediately Dangerous" only if you have disconnected the appliance or made it safe
      </p>
    </div>
  );
}